import { format } from 'date-fns'

import {
  AdvanceActivityParams,
  AdvanceActivityResponse,
  AdvanceQuote,
  AdvanceQuoteRequest,
  AdvanceRequest,
  AdvanceRequestResponse,
  BranchVerification,
  PayrollSchedules,
  ReportedEarningsParams,
  ReportedEarningsResponse,
  ReportedHoursParams,
  ReportedHoursResponse,
  TransactionBalance,
} from '@/types/ewa'

import { http } from './http'

export const getBranchVerification = () =>
  http.get<BranchVerification>('p2/pay_access/branch_verification')

export const getTransactionBalance = () =>
  http.get<TransactionBalance>('p2/pay_access/transaction_balance')

export const getPayrollSchedules = () =>
  http.get<PayrollSchedules>('p2/pay_access/payrolls/period/details', {
    params: {
      contains_date: format(new Date(), 'yyyy-MM-dd'),
    },
  })

export const postAdvanceQuote = (body: AdvanceQuoteRequest) =>
  http.post<AdvanceQuote>('p2/pay_access/quotes', body)

export const requestAdvance = (body: AdvanceRequest) =>
  http.post<AdvanceRequestResponse>('p2/pay_access/advances', body, {
    params: {
      user_consented: true,
    },
  })

export const getAdvanceActivity = (params: AdvanceActivityParams) =>
  http.get<AdvanceActivityResponse>('/p2/pay_access/advances/grouped_by', {
    params: { ...params, group_by: 'PAYROLL_PERIOD' },
  })

export const downloadAdvanceAgreement = (advanceId: string) =>
  http.get<ArrayBuffer>(`p2/pay_access/advances/${advanceId}/agreement`, {
    responseType: 'arraybuffer',
  })

export const getReportedHours = (params: ReportedHoursParams) =>
  http.get<ReportedHoursResponse>('p2/pay_access/tracked_times', { params })

export const getReportedEarnings = (params: ReportedEarningsParams) =>
  http.get<ReportedEarningsResponse>('p2/pay_access/period_earnings', {
    params,
  })
